// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dy9F","clinicsSelect":"styles_clinicsSelect__28wgr"};